import { render, staticRenderFns } from "./masseur.vue?vue&type=template&id=df1001f2&"
import script from "./masseur.vue?vue&type=script&lang=js&"
export * from "./masseur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports